import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd6d50b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-url-redeem" }
const _hoisted_2 = { class: "m-url-product-selection" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "qty-counter"
}
const _hoisted_6 = {
  key: 1,
  class: "m-url-variant-selection"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "m-url-variant-dropdown" }
const _hoisted_9 = ["value", "onClick"]
const _hoisted_10 = { class: "m-url-variant-selected-option" }
const _hoisted_11 = ["for"]
const _hoisted_12 = { class: "m-url-confirm" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.shopifyProducts, (product, idx) => {
        return (_openBlock(), _createElementBlock("button", {
          key: idx,
          class: _normalizeClass(["selectable", { selected: _ctx.selectedProductIdx == idx }]),
          onClick: ($event: any) => (_ctx.selectProduct(idx))
        }, [
          _createElementVNode("img", {
            src: 
            product && product.productData && product.productData.image
              ? product.productData.image.src
              : ''
          
          }, null, 8, _hoisted_4),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(product ? product.productData.title : ''), 1)
          ])
        ], 10, _hoisted_3))
      }), 128))
    ]),
    (_ctx.maxQuantityCount && _ctx.maxQuantityCount > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", null, "Qty: " + _toDisplayString(_ctx.quantityCount), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.decrementQuantityCount()))
          }, "-"),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.incrementQuantityCount()))
          }, "+")
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.shopifyProducts[_ctx.selectedProductIdx].productData.variants.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.shopifyProducts[_ctx.selectedProductIdx].productData.options, (option, optionIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: optionIdx,
              class: _normalizeClass(["m-url-variant-option", { open: _ctx.openOptionDropdown[optionIdx] }]),
              onClick: ($event: any) => (_ctx.openOption(optionIdx))
            }, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.values, (value, valueIdx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: valueIdx,
                    value: value,
                    class: _normalizeClass({
              selected: _ctx.selectedOptions[optionIdx] == value
            }),
                    onClick: ($event: any) => (_ctx.changeOption(optionIdx, value))
                  }, _toDisplayString(value), 11, _hoisted_9))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.selectedOptions[optionIdx]), 1),
              _createElementVNode("label", {
                for: option.name
              }, _toDisplayString(option.name), 9, _hoisted_11)
            ], 10, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, "Cancel"),
      _createElementVNode("button", {
        disabled: _ctx.submissionDisabled,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitSelection && _ctx.submitSelection(...args)))
      }, " Submit ", 8, _hoisted_13)
    ])
  ]))
}